module.exports = function getResource(label, vars = []) {
    let resources = {
        close: 'Fermer',
        itemAdded: 'Article ajouté au panier',
        viewBasketAndReserve: 'Voir le panier et réserver',
        viewBasketAndCheckout: 'Voir le panier et passer à la caisse',
        ropisItemAdded: 'L’article a été ajouté à votre panier',
        pickUpAt: 'pour ramassage au ',
        checkout: 'Passer à la caisse',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.',
        testCreditCardMessageTitle: 'Don’t Forget to Use Your Sephora Credit Card',
        testCreditCardSeeDetails: 'Voir les détails'
    };

    return resources[label];
};
